import type { MenuPageSourceConnection } from '../discover/components/restaurant/menu/types';
import { publicHttpUrl } from './publicUrl';

type MenuSource = {
  menus?: MenuPageSourceConnection | null;
  menuLink?: string | null;
};

export const getRestaurantMenuLink = (restaurant: Pick<MenuSource, 'menuLink'>) =>
  publicHttpUrl(restaurant.menuLink);

export const hasMenuImages = (menus?: MenuPageSourceConnection | null) =>
  (menus?.edges || []).some(({ node }) =>
    (node?.menuImages?.edges || []).some((edge) => Boolean(edge?.node?.url))
  );

// The sitemap, the /menu route and the JSON-LD decide "has a menu" here, from the menu records alone, so a change to how PhotoSwipe sizes images cannot change what is indexable.
export const hasRestaurantMenu = (restaurant: MenuSource) =>
  hasMenuImages(restaurant.menus) || Boolean(getRestaurantMenuLink(restaurant));

// Date and party size are URL state on restaurant pages, so the menu page link and the link back from it have to carry the query string across.
export const getRestaurantMenuPaths = (slug: string, asPath = '') => {
  const search = asPath.match(/\?[^#]*/)?.[0] ?? '';
  return { restaurantPath: `${slug}${search}`, menuPath: `${slug}/menu${search}` };
};
